
<template>
  <div class="banner-search">
    <div v-if="title" class="title">
      <span>{{ this.title }}</span>
    </div>
    <div v-else class="innerbox">
      <div class="router"
        :class="{ 'art': this.$route.name == 'Article' || this.$route.name == 'active', 'zh': $i18n.locale == 'zh' }">

        <router-link to="/" class="white"> {{ $t("m.banner.support") }} </router-link>
        <img style="width:12px" class="nobtn" v-if="this.$route.name != 'search results'"
          src="../assets/images/path_arrow.svg" alt="" />
        <router-link class="white" to="/tickets/my-tickets" v-if="this.$route.name == 'MyTicket'">{{
          $t("m.ticket.MyTicket")
        }}</router-link>

        <a class="btn tip" v-else-if="this.$route.name == 'KNOW ISSUES'">{{ htmlDecode(myclass) }}</a>
        <a class="btn tip art" v-else-if="this.$route.name == 'Article'">
          <router-link class="white" :to="'/faq/#topic=' + artClass.id">{{ htmlDecode(artClass.name) }}</router-link>
          <!-- <img style="width:12px" src="../assets/images/path_arrow.svg" alt="" />
          <router-link class="white" :to="'/faq/' + myclass.id">{{ myclass.name
          }}</router-link> -->
        </a>
        <a class="btn tip" v-else-if="this.$route.name == 'active'">
          <router-link class="white" :to="'/faq/#topic=' + myclass.id">{{
            myclass.name
          }}</router-link>
          <img style="width:12px" src="../assets/images/path_arrow.svg" alt="" />
          <a>{{ subClass
          }}</a>
        </a>
        <a class="btn tip" v-else-if="this.$route.name == 'submit a ticket'">{{ $t("m.bannerSearch.submit") }}</a>
        <a class="btn tip" v-else-if="this.$route.name == 'Myticket'">{{ $t("m.bannerSearch.MyTicket") }}</a>
        <a class="btn tip" v-else-if="this.$route.name == 'search results'"></a>
        <a class="btn tip" v-else>{{ this.$route.name }}</a>
      </div>
      <img class="nemo" src="../assets/images/nemo.png" alt="">
      <div class="inp-box">
        <img class="search" src="../assets/images/search_icon.svg" alt="" />

        <input type="text" :placeholder="$t('m.banner.search')" @keyup.enter="goSearch()" v-model="search" />
      </div>
    </div>

  </div>
</template>
 
<script>
//此页为通用页头
export default {
  name: "BannerSearch",
  props: ['title'],
  data() {
    return {
      subClass: '',
      myclass: '',
      subId: "",
      search: '',
      article: '',
      artClass: '',
    };
  },
  watch: {
    '$route.hash'() {
      this.getName()
    },
    '$route.params.name'() {
      this.getName()
    }
  },
  mounted() {


    this.getName()
    if (this.$route.query.search) {
      this.search = this.$route.query.search
    }
  },
  methods: {
    decodeHTMLEntities(input) {
      const entities = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
        // 可根据需要添加其他转义字符和对应的替换值
      };

      return input.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, match => entities[match]);
    },
    htmlDecode(s) {
      var doc = new DOMParser().parseFromString(s, "text/html");
      return doc.documentElement.textContent;
    },
    searchQuery(query) {
      this.$refs.search.executeQuery(query);  // 设置查询词
    },
    getName() {
      console.log("111222");
      var count = 0
      let timer = setInterval(() => {
        count++
        if (count >= 50) {
          clearInterval(timer)
        }
        if (this.$store.state.class != '') {
          clearInterval(timer)
          if (this.$route.name == 'Article') {
            this.$store.state.class.map(item => {
              console.log(item);
              item.posts.map(it => {
                console.log(it.id, this.$route.query.id);


                if (it.id == this.$route.query.id) {
                  this.article = it
                  this.myclass = it
                  this.artClass = item
                  console.log(this.article, this.myclass, this.artClass);
                }
              })

            })
          }
          if (this.$route.hash.indexOf('#') != -1) {

            this.$store.state.class.map(items => {
              console.log(items, items.id, this.$route.hash.replace('#topic=', ''));
              if (items.id == this.$route.hash.replace('#topic=', '')) {

                this.myclass = items.name
              }
            })
          } else {
            this.$store.state.class.map(items => {
              items.posts.map(it => {
                if (it.id == this.$route.params.name) {
                  this.myclass = items
                  console.log(items);
                  this.subClass = it.name
                }
              })
            })
          }

        }
      })
    },
    goSearch() {
      console.log(this.$router);
      this.$router.push({
        name: 'search results',
        query: {
          search: this.search,
        }
      })
    },
  },
  created() { },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/bannersearch.scss";
</style>